import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type QuickSearchProjectV2Fragment = { __typename?: 'Project', id: string, name: string, insertedAt: string, private: boolean, archivedAt?: string | null, imageUrl?: string | null, memberCount?: number | null, totalCount?: number | null, storage: number, uniqueMemberCount?: number | null, notificationsEnabled?: boolean | null, workspace?: { __typename?: 'Workspace', name: string, id: string } | null, owner?: { __typename?: 'AuthenticatedUser', name?: string | null } | null };

export type NewProjectFieldsV2Fragment = { __typename?: 'Project', imageUrl?: string | null, memberCount?: number | null, totalCount?: number | null, storage: number, uniqueMemberCount?: number | null, archivedAt?: string | null, private: boolean, notificationsEnabled?: boolean | null, workspace?: { __typename?: 'Workspace', name: string, id: string } | null, owner?: { __typename?: 'AuthenticatedUser', name?: string | null } | null };

export const NewProjectFieldsV2 = /*#__PURE__*/ gql`
    fragment NewProjectFieldsV2 on Project {
  imageUrl
  memberCount
  workspace {
    name
    id
  }
  owner {
    name
  }
  totalCount
  storage
  uniqueMemberCount
  archivedAt
  private
  notificationsEnabled
}
    ` as unknown as DocumentNode<NewProjectFieldsV2Fragment, unknown>;
export const QuickSearchProjectV2 = /*#__PURE__*/ gql`
    fragment QuickSearchProjectV2 on Project {
  id
  name
  insertedAt
  private
  archivedAt
  ...NewProjectFieldsV2
}
    ${NewProjectFieldsV2}` as unknown as DocumentNode<QuickSearchProjectV2Fragment, unknown>;

        

        
export const useQuickSearchProjectV2Fragment = (
  input: string | Omit<UseFragmentOptions<QuickSearchProjectV2Fragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Project' } };
    return input;
  })();

  return useFragment<QuickSearchProjectV2Fragment>({
    fragment: QuickSearchProjectV2,
    fragmentName: 'QuickSearchProjectV2',
    ...options,
  });
};
  
        
        

        
export const useNewProjectFieldsV2Fragment = (
  input: string | Omit<UseFragmentOptions<NewProjectFieldsV2Fragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Project' } };
    return input;
  })();

  return useFragment<NewProjectFieldsV2Fragment>({
    fragment: NewProjectFieldsV2,
    fragmentName: 'NewProjectFieldsV2',
    ...options,
  });
};
  
        